module.exports = __webpack_public_path__ + "hotpFactor_38x38.2555997b5717d28c4ffa8973f08eb805.png";